var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listData.length > 0)?_c('ul',{staticClass:"listview-wrap",class:_vm.cls},[_vm._t("preItem"),_vm._l((_vm.listData),function(item,index){return _vm._t("item",null,{"item":item,"index":index})}),_vm._t("aftItem")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }